/**
 *
 * @module geo/services
 */
import { Exception } from 'handlebars';
import { Observable } from 'rxjs/Observable';


import { serviceFeatureTransactionCreatorP } from '../actions/creators/services.creator';
import { SERVICE_FEATURE_TRANSACTION } from '../payload/facade/services/SERVICE_FEATURE_TRANSACTION';
import { FeaturesTransaction } from '../types/services/features.transaction';
import { Feature } from '../types';
import { FeatureTransactionOperation, FeatureTransactionResult, OperationType } from '../types/feature.transaction.operation';

import { Service } from './index';
import { fromPromise } from 'rxjs/observable/fromPromise';



/**
 * Feature transaction service
 * Service to build and save operations on geometry and data, related to
 * geometryModification or infoSheet resources
 *
 * Exemple:
 * ```
 *
 * var addOp =
 * geoApp.Services.FeatureTransaction.buildOperation(features,geometryModifId,'ADD');
 * geoApp.Services.FeatureTransaction.save(addOp).subscribe((results)=>{
 *  console.log (results[0].nbCreated + ' objects created')
 * });
 *
 *  ```
 *
 *
 * @since 2.1.0
 */
export class FeatureTransactionService extends Service {

  /**
   * An helper Build operations to be use in save method by calling REST service
   * see [[save]]
   *
   * @param features list of features concerned by operation
   * @param sourceId id of functionality (geometrymodification or infosheet)
   * @param type operation name : INSERT, DELETE or UPDATE
   *
   */
  public buildOperation(
    features: Feature[], sourceId: string,
    type: OperationType): FeatureTransactionOperation[] {
    if (features.length === 0) {
      throw new Error('No features');
    }
    return [{ features, source: sourceId, operation: type }]
  }

  /**
   * Commit  operations
   * It is possible to combine multiple operation
   *
   * ```
   * var addOp =
   * geoApp.Services.FeatureTransaction.buildOperation(features,geometryModifId,'ADD');
   * geoApp.Services.FeatureTransaction.save(addOp).subscribe((results)=>{
   *  console.log (results[0].nbCreated + ' objects created')
   * });
   * ```
   * @param operations list of operation to commit. see [[buildOperation]]
   *
   */
  public save(operations: FeatureTransactionOperation[], transientService?: boolean, idService?: string):
    any {
    if (operations.length === 0) {
      return Observable.empty();
    }
    let { id, transient } = this.getIdAndTransient({ transient: transientService, id: idService })
  
    const actionsOptions = new SERVICE_FEATURE_TRANSACTION(
      {
        parameters:{ 
          data: operations
        },
        id,
        transient

      }

    );

    return fromPromise(serviceFeatureTransactionCreatorP(actionsOptions, this.store.dispatch));

  }
}
